export default __webpack_public_path__ + "static/onchainart-f5a0439daa10dbc4e23b505466017c96.jpg";